module.exports = __webpack_public_path__ + "static/media/answerWindow.8f0d2741.png";